import React from 'react';
import SmartLink from '../../utils/SmartLink';
import LogoMedata from '../../medatatheme/assets/images/logo.png';
import LogoAlcaldiaVertical from '../../medatatheme/assets/images/logo-alcaldia-blanco.png';
import Menu from './menu';

// El header contiene SOLO la barra de navegación (logos + menú + login). El hero
// de la home vive en el flujo del <main> (componente HomeHero), no aquí, para que
// el header fijo no solape el contenido.
const Header = ({ headerClass = 'header' }) => {
  return (
    <header className={headerClass} id="header">
      <nav className="navbar container-home">
        <div className="logos">
          <a href="https://www.medellin.gov.co/" className="brand">
            <img src={LogoAlcaldiaVertical} alt="Logo alcaldía de Medellín" />
          </a>
          <SmartLink to="/" className="logo">
            <img src={LogoMedata} alt="Logo MeData" />
          </SmartLink>
        </div>
        <div className="nav-right">
          {/* El botón "Iniciar sesión" se trasladó al footer (componente footer,
              .admin-access-bar): un engranaje discreto que al pasar el mouse
              revela "Iniciar sesión". Aquí ya no se muestra en el header. */}
          <input id="menu-toggle" type="checkbox" aria-hidden="true" />
          <label className="menu-button-container" htmlFor="menu-toggle"></label>
          <div className="burger" id="burger">
            <span className="burger-line"></span>
            <span className="burger-line"></span>
            <span className="burger-line"></span>
          </div>
          <div className="menu" id="menu">
            <div className="menu-container">
              <div className="logos-mobile">
                <a href="https://www.medellin.gov.co/" className="brand">
                  <img
                    src={LogoAlcaldiaVertical}
                    alt="Logo alcaldía de Medellín"
                  />
                </a>
                <SmartLink to="/" className="logo">
                  <img src={LogoMedata} alt="Logo MeData" />
                </SmartLink>
              </div>
              <Menu />
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
